export const usersSingleTeacherDictionary = {
  beginTime: 'O’qish boshlangan sana',
  endTime: 'O’qish tuga(ydi)gan sana',
  userTeacherName: "Guruh o'qituvchisi",
  userAssistantName: 'Guruh assistantlari',
  accessLesson: "Dars o'tishi",
  teacherAttendec: 'O’qituvchi davomati',
}
